import React, { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";

// Section for Utilities and Context
import "./divisionlist.css";
import { districtLabel } from "../utils/district";

export default function DivisionList(props) {
    const navigate = useNavigate();
    const [divisions, setDivisions] = useState([]);
    const [divisionTypes, setDivisionTypes] = useState([]);
    const [filterSelect, setFilterSelect] = useState(undefined);

    useEffect(() => {
        if (Array.isArray(props.divisions)) {
            const activeDivisions = props.divisions.filter(div => div.active_division === true);
            setDivisions(activeDivisions);

            const types = [...new Set(
                props.divisions?.map(division => division.division_type)
                    .filter(Boolean))]
                    .sort((a, b) => a.localeCompare(b));

            setDivisionTypes(types);
        }
    }, [props.divisions]);

    const handleNavigate = (division_id) => {
        navigate("/division/" + division_id);
    }

    const formatPhoneNumber = (phone) => {
        if (!phone) return '';
        const cleaned = ('' + phone).replace(/\D/g, '');
        const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
        return match ? `(${match[1]}) ${match[2]}-${match[3]}` : phone;
    };

    const filteredDivisions = useMemo(() => {
        if (!Array.isArray(divisions)) {
            return [];
        }
        return divisions
            .filter(div => filterSelect === undefined || div.division_type === filterSelect)
            .sort((a, b) => a.division_name.localeCompare(b.division_name));
    }, [divisions, filterSelect]);

    const divisionCards = useMemo(() => {
        if (filteredDivisions.length === 0) {
            return <div className="py-2 ms-3">No divisions or offices to list.</div>;
        }
        return filteredDivisions.map((div) => (
            <div key={div.division_id}
                className="division-card"
                onClick={() => handleNavigate(div.division_id)}
            >
                <div className="division-card-details">
                    <span className="division-card-name">{div.division_name}</span>
                    {div.division_type && (
                        <span className="division-card-type">{div.division_type}</span>
                    )}
                    {div.district && (
                        <span className="division-card-type">{districtLabel(div.district)}</span>
                    )}
                    {(div.street_address || div.city) && (
                        <span className="division-card-address">
                            {div.street_address}
                            {div.suite_number && `, Suite ${div.suite_number}`}
                            {div.street_address && (div.city || div.state) && ", "}
                            {[div.city, div.state].filter(Boolean).join(", ")}
                            {div.zip_code && ` ${div.zip_code}`}
                        </span>
                    )}
                    {div.division_phone && (
                        <span className="division-card-phone">{formatPhoneNumber(div.division_phone)}</span>
                    )}
                    {div.website && (
                        <a href={div.website.startsWith("http") ? div.website : `https://${div.website}`}
                            className="division-card-website"
                            target="_blank" rel="noopener noreferrer"
                            onClick={(e) => e.stopPropagation()}
                        >{div.website}</a>
                    )}
                </div>
            </div>
        ));
    }, [filteredDivisions]);

    const handleResetFilters = () => {
        setFilterSelect(undefined);
    };

    return (
        <div className="division-feed">
            {divisionTypes.length > 1 && (
                <div className="division-filter-bar">
                    {divisionTypes.map((type) => (
                        <button key={type}
                            className={`division-filter-button ${filterSelect === type ? "selected" : ""}`}
                            onClick={() => setFilterSelect(type)}
                        >{type}</button>
                    ))}

                    <button
                        className="clear-division-filter-button"
                        onClick={handleResetFilters}
                    >Reset</button>
                </div>
            )}

            <div className="division-card-grid">
                {divisionCards}
            </div>
        </div>
    );
}
